import { Licence } from "./Licence";
import { LicenceInfoV3 } from "./LicenceInfoV3";
import { RecordInfo } from "./RecordInfo";

export enum LicenceVersion {
  V2 = "V2",
  V3 = "V3",
}

export interface LicenceInfo {
  id: string;
  installationId?: string | null;
  deviceName?: string;
  lastUpdatedBy?: RecordInfo | null;
  licences: Licence[];
}

export interface LicenceInfoOfClient {
  licenceVersion: LicenceVersion;
  licenceDetailsV3?: LicenceInfoV3;
}